import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../global/Button';
import { formatPhone } from '../../../../util/phone';

const propTypes = {
  transaction: PropTypes.shape({
    id: PropTypes.string,
    print_partner: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      contact_phone: PropTypes.string,
      contact_email_address: PropTypes.string,
    }),
  }).isRequired,
};
const PrintPartnerContactForm = ({ transaction }) => {
  const {
    uuid: orderNumber,
    roes_order_id: roesOrderNumber,
    print_partner: printPartner,
  } = transaction;

  const {
    name,
    contact_phone_number: phone,
    contact_email_address: email,
    roes_info: roesInfo,
  } = printPartner ?? {};

  if (!phone && !email) {
    return null;
  }

  const emailSubject = 'Problem with an order';
  const bodyBreak = '%0D%0A';
  const emailBody = `Hello, I'd like to request help with the following order:${bodyBreak}${bodyBreak}Waldo order number: ${orderNumber}${bodyBreak}${
    roesOrderNumber ? `ROES order number: ${roesOrderNumber}${bodyBreak}` : ''
  }${roesInfo?.lab_id ? `Lab ID: ${roesInfo?.lab_id}${bodyBreak}` : ''}`;

  return (
    <div className="text-light text-center mt-2">
      Need help from {name}? <br />
      {email && (
        <div>
          Email them at{' '}
          <Button
            btnStyle="link"
            className="btn-primary"
            href={`mailto:${email}?subject=${emailSubject}&body=${emailBody}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {email}
          </Button>
        </div>
      )}
      {phone && (
        <div>
          {email ? 'or call' : 'Call'} them at {formatPhone(phone)}
        </div>
      )}
    </div>
  );
};

PrintPartnerContactForm.propTypes = propTypes;

export default PrintPartnerContactForm;
